<template>
	<div
		v-touch:tap="tapHandler"
		v-touch:swipe.left="swipeLeftHandler"
		v-touch:swipe.right="swipeRightHandler"
		@contextmenu.prevent="contextMenuHandler"
		style="user-select: none"
		@keyup.enter="tapHandler"
		tabindex="0"
		role="link"
	>
		<template v-if="data">
			<button
				class="btn btn-danger float-right"
				v-if="showDeleteBtn"
				v-touch:tap.stop="deleteTreatmentSession"
			>
				{{$t('delete')}}
			</button>

			<Avatar
				class="avatar float-left mr-4 mb-3 lg:mb-0"
				:userId="data.student"
				v-if="isTeacher"
			/>

			<p class="mb-1 mt-1 font-bold" v-if="isTeacher">
				{{ data.student_displayname }}
				<template v-if="this.$config.getValue('showflagsinlist') && user">
					<template v-if="user.flags.length">
						<template v-for="flag in user.flags">
							<span
								class="userflag mr-1 mb-1"
								:key="flag.name"
								:class="[flag.value]"
								>{{ flag.name }}</span
							>
						</template>
					</template>
				</template>
				<span
					class="badge badge-pill badge-secondary mr-1 ml-1 mb-1"
					v-if="!data.isLocked"
					>{{ $t("not-marked") }}</span
				>
				<span class="badge badge-pill badge-success mr-1 ml-1 mb-1" v-if="data.isLocked">{{
					$t("marked")
				}}</span>
				<span
					class="badge badge-pill badge-danger mr-1 ml-1 mb-1"
					v-if="Number(data.patientAttendance) >= 2"
					>{{ $t("patient-did-not-attend") }}</span
				>
				<span
					class="badge badge-pill badge-success mr-1 ml-1 mb-1"
					v-if="data.hasPatientFeedback"
					>{{ $t("patient-feedback") }}</span
				>
				<span
					class="badge badge-pill badge-success mr-1 ml-1 mb-1"
					v-if="data.studentFeedback">{{ $t("student-reflection") }}</span
				>
			</p>
			<p class="mb-1 mt-1 font-bold" v-if="!isTeacher">
				{{ $t("id-colon") }} {{ data.id }}
				<template v-if="this.$config.getValue('showflagsinlist') && user">
					<template v-if="user.flags.length">
						<template v-for="flag in user.flags">
							<span
								class="userflag mr-1 mb-1"
								:key="flag.name"
								:class="[flag.value]"
								>{{ flag.name }}</span
							>
						</template>
					</template>
				</template>
				<span
					class="badge badge-pill badge-secondary mr-1 ml-1 mb-1"
					v-if="!data.isLocked"
					>{{ $t("not-marked") }}</span
				>
				<span class="badge badge-pill badge-success mr-1 ml-1 mb-1" v-if="data.isLocked">{{
					$t("marked")
				}}</span>
				<span
					class="badge badge-pill badge-danger mr-1 ml-1 mb-1"
					v-if="Number(data.patientAttendance) >= 2"
					>{{ $t("patient-did-not-attend") }}</span
				>
				<span
					class="badge badge-pill badge-success mr-1 ml-1 mb-1"
					v-if="data.hasPatientFeedback"
					>{{ $t("patient-feedback") }}</span>
			</p>
			<ul class="list-bare clear-lg-none clearfix" style="overflow: hidden">
				<li class="mr-3 float-lg-left text-sm">
					<template
						v-for="participationType in this.$config.getValue('participationTypes')"
					>
						<li
							class="mr-3 float-lg-left text-sm"
							v-bind:key="participationType.id"
							v-if="participationType.id == data.typeId"
						>
							{{ participationType.name }}
							<template v-if="$config.getValue('showpatientid') && data.patient">
								({{ data.patient }})
							</template>
						</li>
					</template>
				</li>

				<li class="mr-3 float-lg-left text-sm">
					{{ data.clinicName }}
				</li>
				<li class="mr-3 float-lg-left text-sm" v-if="isTeacher">
					{{ $t("id-colon") }} {{ data.id }}
				</li>
				<li class="mr-3 float-lg-left text-sm">
					{{ $datetime.getLocaleStringFromTimeStamp(data.treatmentTimestamp , false) }}
				</li>
				<li class="mr-3 float-lg-left text-sm">
					{{ $t("teacher-colon") }} {{ data.teacher_displayname }}
				</li>
				<li
					class="float-lg-left text-sm"
					v-if="data.chairNumber && this.$config.getValue('showchairnumber')"
				>
					{{ $t("chair-no-colon") }} {{ data.chairNumber }}
				</li>
				<li
					class="mr-3 float-lg-left text-sm"
					v-if="data.patientFeedbackDate && canManageSessions"
				>
					{{ $t("patient-feedback-date-colon") }} {{ $datetime.getLocaleStringFromTimeStamp(data.patientFeedbackDate, false) }}
				</li>
			</ul>
		</template>

		<template v-else>
			<div class="avatar float-left mr-4 mb-3 lg:mb-0 skeleton"></div>
			<div class="float-left">
				<div class="skeleton midnight h20 w200 mb-3"></div>
				<div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import Avatar from "../../../Avatar.vue";
export default {
	props: ["data", "swipedLeftItem"],
	components: {
		Avatar,
	},
	data() {
		return {
			user: null,
			mouseDownClientX: null,
			mouseDownClientY: null,
		};
	},
	mounted() {
		if (this.data) {
			this.getUserDetails();
		}
	},
	created: function () {},
	destroyed: function () {},
	methods: {
		deleteTreatmentSession() {
			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/delete`, {
				data: {
					id: this.data.id,
				},
			})
				.then((json) => {
					if (json.status.toLowerCase() === "success") {
						this.$emit("removeItem", this.data);
					}
				})
				.catch((error) => {
					this.$log.error.call(this, error);
				});
		},
		tapHandler(e) {
			// ignore for right clicks
			if (e.button && e.button == 2) {
				return false;
			}

			if (this.data) {
				this.$emit("selectItem", this.data);
			}
		},
		mouseDownHandler(e) {
			this.mouseDownClientX = e.clientX;
			this.mouseDownClientY = e.clientY;
		},
		swipeLeftHandler() {
			this.$emit("swipeLeftItem", this.data);
		},
		swipeRightHandler() {
			this.$emit("swipeRightItem", this.data);
		},
		contextMenuHandler() {
			this.$emit("contextMenuItem", this.data);
		},
		getUserDetails() {
			this.$users.getUserById.call(this, this.data.student).then((user) => {
				this.user = user;
			});
		},
	},
	computed: {
		showDeleteBtn() {
			return (
				this.swipedLeftItem &&
				this.swipedLeftItem.id == this.data.id &&
				(this.$UserSession.hasPriv.call(this, "TREATMENTSESSION_DELETE")
                    || (this.$UserSession.hasPriv.call(this, "TREATMENTSESSION_DELETE_STUDENT")
                        && !this.data.isLocked)
                )
			);
		},
		isTeacher() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		},
		canManageSessions() {
			return this.$UserSession.hasPriv.call(this, "TREATMENTSESSION_MANAGE");
		},
	},
};
</script>
